import React from 'react';

import {Sections, SectionsProps} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeSection';
import {
  StandardSection,
  StandardSectionProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSection';

export interface StandardSectionsProps {
  /** Data about the sections to be displayed within this wrapper */
  sections: Array<StandardSectionProps>;
}

/**
 * A standard wrapper for sections within a {@link BenchlingNodeV2}. It consumes the context provided by
 * {@link BenchlingNodeV2}, and as such automatically handles section row counts.
 * @package
 */
export function StandardSections(props: StandardSectionsProps & SectionsProps): JSX.Element {
  const {sections, ...sectionsProps} = props;
  return (
    <Sections {...sectionsProps}>
      {sections.map((sectionProps) => (
        <StandardSection key={sectionProps.name} {...sectionProps} />
      ))}
    </Sections>
  );
}
